import React, { useState, useEffect } from 'react';
import { europeanCountries, TOAST_OPTIONS } from "../../constants";

//UTILS
import { isMobile } from "react-device-detect";
import { ToastContainer, toast } from 'react-toastify';
import UserService from '../../services/user_services';

//COMPONENTS
import Header from "../../components/header";
import FollowUp from "../../components/followup";
import Button from "../../components/button";
import { ThreeDots } from "react-loader-spinner";

//VISUALS
import BANNER_VISUAL from "../../assets/images/girl_back_lifise.jpg";
import LOGO_WHITE from "../../assets/images/full_white.png";

//TRANSLATION
import { useTranslation } from 'react-i18next';

const SignIn = ({ magic }) => {
    const { t } = useTranslation();
    const [email, onChangeEmail] = useState();
    const [loading, onChangeLoading] = useState(false);
    const [success, onChangeSuccess] = useState(false);
    const [displayPhone, onChangeDisplayPhone] = useState(false);
    const [countryCode, onChangeCountryCode] = useState('33');
    const [phoneNumber, onChangePhoneNumber] = useState(null);
    const [did, onChangeDid] = useState(null);
    const [twoFAToken, onChangeTwoFAToken] = useState(null);

    const homeRedirect = () => window.location.href = "/"

    const handleCountryChange = (e) => {
        const selectedCode = e.target.value;
        onChangeCountryCode(selectedCode);
    };

    const magicLogin = async () => {
        // eslint-disable-next-line
        let re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
        if (!email || !re.test(email)) {
            toast.error(t('signin.error_email'), TOAST_OPTIONS);
        } else {
            try {
                onChangeLoading(true);
                const status = await UserService.checkEmail(email.toLowerCase())
                if (status) {
                    const didToken = await magic.auth.loginWithEmailOTP({ email: email.toLowerCase() });
                    onChangeDid(didToken);
                    const resp = await UserService.login(didToken);
                    console.log(resp);
                    if (resp.status) {
                        if (resp.phone_status) {
                            onChangeSuccess(true);
                            onChangeLoading(false);
                        } else {
                            onChangeDisplayPhone(true);
                            onChangeLoading(false);
                        }
                    } else {
                        toast.error(t(resp.message), TOAST_OPTIONS);
                        onChangeLoading(false);
                    }
                } else {
                    toast.error(t('signin.no_account_found'), TOAST_OPTIONS);
                    onChangeLoading(false);
                }
            } catch (e) {
                console.log(e);
                toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                onChangeLoading(false);
            }
        }
    }

    const loginTwoFA = async () => {
        if (!twoFAToken) {
            toast.error(t('signup.set_code'), TOAST_OPTIONS);
        } else {
            try {
                onChangeLoading(true);
                const resp = await UserService.twofaLogin(twoFAToken, did);
                if (resp.status) {
                    window.location.href = "/dashboard"
                }
                else {
                    toast.error(t(resp.message), TOAST_OPTIONS);
                    onChangeLoading(false);
                    onChangeSuccess(false);
                }
            } catch (e) {
                console.log(e);
                toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                onChangeLoading(false);
                onChangeSuccess(false);
            }
        }
    }

    const updtPhone = async () => {
            if (!countryCode || !phoneNumber) {
                toast.error(t('signin.set_phone'), TOAST_OPTIONS);
            } else {
                try {
                    onChangeLoading(true);
                    const phone = `+${countryCode}${phoneNumber}`;
                    const resp = await UserService.updatePhone(phone, did);
                    console.log(resp);
                    if (resp.status) {
                        onChangeSuccess(true);
                        onChangeLoading(false);
                    }
                    else {
                        toast.error(t(resp.message), TOAST_OPTIONS);
                        onChangeLoading(false);
                    }
                } catch (e) {
                    console.log(e);
                    toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                    onChangeLoading(false);
                }
            }
        }

    const logout = async () => {
        await magic.user.logout()
    }

    useEffect(() => {
        logout();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {isMobile && <Header />}
            <div className="container mt-0">
                <div className="left_sign" style={{ backgroundImage: `url('${BANNER_VISUAL}')` }}>
                    <img src={LOGO_WHITE} alt="Lifise logo" className="logo" onClick={homeRedirect} />
                </div>
                <div className="right_sign">
                    <p className="instructions">{t('signin.fill_required_info')}</p>
                    <h1>{t('signin.access_account')}</h1>
                    {success ?
                        <React.Fragment>
                            <div>
                                <label className="ml-0">{t('signin.fatoken')}</label>
                                <input type="text" className="semi mt-10" placeholder={t('signin.code')} onChange={e => onChangeTwoFAToken(e.target.value)} />
                            </div>
                            {!loading && <>
                                <Button title={t('signin.confirm')} click={loginTwoFA} />
                            </>}
                        </React.Fragment>
                        :
                        displayPhone ?
                            <React.Fragment>
                                <h5>{t('signin.missing_phone')}</h5>
                                <div className="display-inline-block mr-20 mt-0">
                                    <label>{t('signup.country')}</label>
                                    <select className="semi" onChange={handleCountryChange} value={countryCode || '33'}>
                                        {europeanCountries.map((country) => (
                                            <option key={country.code} value={country.code}>
                                                {country.name} (+{country.code})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="display-inline-block mt-0">
                                    <label>{t('signup.phone_number')}</label>
                                    <input type="tel" className="semi" placeholder="123456789" onChange={e => onChangePhoneNumber(e.target.value)} />
                                </div>
                                {!loading &&
                                    <>
                                        <Button title={t('signin.update_phone')} click={updtPhone} />
                                    </>}
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <label>{t('signin.email_address')}</label>
                                <input type="text" placeholder={t('signin.email_address')} onChange={e => onChangeEmail(e.target.value)} />
                                <label className="mt-10">Powered by <a href="https://magic.link" target="_blank" rel="noreferrer">Magic.link</a></label>
                                {!loading &&
                                    <>
                                        <Button title={t('signin.sign_in')} click={magicLogin} /> <FollowUp intro={t('signin.no_account')} description={t('signin.create_yours')} link={"/signup"} />
                                    </>}
                            </React.Fragment>}
                    <ThreeDots visible={loading} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                </div>
            </div>
            <ToastContainer />
        </>
    )
};

export default SignIn;